import {
  listScheduleItems as publicListScheduleItems,
  queryScheduleItems as publicQueryScheduleItems,
  typedQueryScheduleItems as publicTypedQueryScheduleItems,
  getScheduleItem as publicGetScheduleItem,
  addScheduleItem as publicAddScheduleItem,
  updateScheduleItem as publicUpdateScheduleItem,
  deleteScheduleItem as publicDeleteScheduleItem,
  discardDraft as publicDiscardDraft,
  publishDraft as publicPublishDraft,
  rescheduleDraft as publicRescheduleDraft,
} from './events-schedule-v1-schedule-item-schedule.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ItemsQueryBuilder,
  ScheduleItemQuery,
  typedQueryScheduleItems as universalTypedQueryScheduleItems,
} from './events-schedule-v1-schedule-item-schedule.universal.js';

function customQueryScheduleItems(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryScheduleItems(httpClient)(),
    typedQueryFunction: (query: ScheduleItemQuery) =>
      publicTypedQueryScheduleItems(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): ItemsQueryBuilder;
  function overloadedQuery(
    query: ScheduleItemQuery
  ): ReturnType<typeof universalTypedQueryScheduleItems>;
  function overloadedQuery(query?: ScheduleItemQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const listScheduleItems: MaybeContext<
  BuildRESTFunction<typeof publicListScheduleItems> &
    typeof publicListScheduleItems
> = /*#__PURE__*/ createRESTModule(publicListScheduleItems);
export const getScheduleItem: MaybeContext<
  BuildRESTFunction<typeof publicGetScheduleItem> & typeof publicGetScheduleItem
> = /*#__PURE__*/ createRESTModule(publicGetScheduleItem);
export const addScheduleItem: MaybeContext<
  BuildRESTFunction<typeof publicAddScheduleItem> & typeof publicAddScheduleItem
> = /*#__PURE__*/ createRESTModule(publicAddScheduleItem);
export const updateScheduleItem: MaybeContext<
  BuildRESTFunction<typeof publicUpdateScheduleItem> &
    typeof publicUpdateScheduleItem
> = /*#__PURE__*/ createRESTModule(publicUpdateScheduleItem);
export const deleteScheduleItem: MaybeContext<
  BuildRESTFunction<typeof publicDeleteScheduleItem> &
    typeof publicDeleteScheduleItem
> = /*#__PURE__*/ createRESTModule(publicDeleteScheduleItem);
export const discardDraft: MaybeContext<
  BuildRESTFunction<typeof publicDiscardDraft> & typeof publicDiscardDraft
> = /*#__PURE__*/ createRESTModule(publicDiscardDraft);
export const publishDraft: MaybeContext<
  BuildRESTFunction<typeof publicPublishDraft> & typeof publicPublishDraft
> = /*#__PURE__*/ createRESTModule(publicPublishDraft);
export const rescheduleDraft: MaybeContext<
  BuildRESTFunction<typeof publicRescheduleDraft> & typeof publicRescheduleDraft
> = /*#__PURE__*/ createRESTModule(publicRescheduleDraft);
export const queryScheduleItems: MaybeContext<
  BuildRESTFunction<typeof customQueryScheduleItems> &
    typeof customQueryScheduleItems
> = /*#__PURE__*/ createRESTModule(customQueryScheduleItems);

export {
  ScheduleStatus,
  StateFilter,
  SortOrder,
} from './events-schedule-v1-schedule-item-schedule.universal.js';
export {
  ScheduleItem,
  TimeInterval,
  ListScheduleItemsRequest,
  Paging,
  ListScheduleItemsResponse,
  FacetCounts,
  PagingMetadataV2,
  Cursors,
  QueryScheduleItemsRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  QueryScheduleItemsResponse,
  GetScheduleItemRequest,
  GetScheduleItemResponse,
  AddScheduleItemRequest,
  ScheduleItemData,
  AddScheduleItemResponse,
  UpdateScheduleItemRequest,
  UpdateScheduleItemResponse,
  DeleteScheduleItemRequest,
  DeleteScheduleItemResponse,
  DiscardDraftRequest,
  DiscardDraftResponse,
  PublishDraftRequest,
  PublishDraftResponse,
  RescheduleDraftRequest,
  RescheduleDraftResponse,
  ListBookmarksRequest,
  ListBookmarksResponse,
  CreateBookmarkRequest,
  CreateBookmarkResponse,
  DeleteBookmarkRequest,
  DeleteBookmarkResponse,
  ListScheduleItemsOptions,
  ItemsQueryResult,
  ItemsQueryBuilder,
  ScheduleItemQuerySpec,
  GetScheduleItemOptions,
  AddScheduleItemOptions,
  UpdateScheduleItemOptions,
  DeleteScheduleItemOptions,
  RescheduleDraftOptions,
} from './events-schedule-v1-schedule-item-schedule.universal.js';
export { utils } from './events-schedule-v1-schedule-item-schedule.universal.js';
export {
  ScheduleStatusWithLiterals,
  StateFilterWithLiterals,
  SortOrderWithLiterals,
  QueryScheduleItemsApplicationErrors,
  CommonQueryWithEntityContext,
  ScheduleItemQuery,
} from './events-schedule-v1-schedule-item-schedule.universal.js';
